import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { loadTags } from "@/lib/tracking";

const Ctx = createContext(null);
const DEFAULTS = { business_name: "Lawn Trial USA", trial_fee: 1, trial_days: 3, service_areas: [], testimonials: [], delivery_options: [] };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const reload = () => api.get("/public/settings").then((r) => { setSettings({ ...DEFAULTS, ...r.data }); loadTags(r.data); }).catch(() => {});
  useEffect(() => { reload(); }, []);
  return <Ctx.Provider value={{ settings, reload }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);

export function useSeo(title, description) {
  const { settings } = useSettings();
  useEffect(() => {
    document.title = `${title} | ${settings.business_name}`;
    let m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description);
  }, [title, description, settings.business_name]);
}
